import {
    BlockerConfig, AjaxStdResponse, BsModal, Blocker,
    Support } from './TS_Controls'






interface InstructorsConfig {
    Panel?: string;
    ModalPanel?: string;
    Endpoint?: string;
    InsertPanel?: string;
    BlockerConfig?: BlockerConfig;
}


interface InstructorItem {
    RecordID?: number;
    FName?: string;
    LName?: string;
    Email?: string;
    About?: string;
}



interface InstructorsResponse extends AjaxStdResponse {
    // EmptyItem: InstructorItem;
    Item: InstructorItem;
    Items: InstructorItem[];
}



export class AdminInstructors {

    private _cfg: InstructorsConfig;
    private _mdl: BsModal;
    private _blk: Blocker;
    private _emptyItem: InstructorItem;

    public NewItem: KnockoutObservableType<InstructorItem>;
    public Items: KnockoutObservableType<InstructorItem>[];


    constructor(config: InstructorsConfig) {

        this._cfg = config;
        this._mdl = new BsModal({
            Panel: config.ModalPanel,
        });
        this._blk = new Blocker(config.BlockerConfig);
        this.Setup();
    }


    private _copy: InstructorItem;
    public ShowEdit(item: KnockoutObservableType<InstructorItem>,
        evt: Event): void {
        /// CRATING A COPY OF OUR OBJECT.
        /// 
        this._copy = ko.mapping.toJS<InstructorItem>(item);

        /*
        OK LET'S FIND OUR EDIT PANEL NEARBY TO THE EDIT BUTTON.
        FIRST LOOK FOR THE CONTAINER PANEL, THEN FOR THE EDIT PANEL
        CONTAINED IN IT.
        */
        let $pnlEdit = $(evt.target).closest('[data-item="panel-item"]')
            .find('[data-item="panel-edit"]');

        this._mdl.Display({
            Title: "Edit Instructor",
            DomObj: $pnlEdit,
            Buttons: [
                {
                    Text: 'Update Instructor',
                    Class: 'btn btn-primary',
                    Callback: (evt) => {
                        this.Editing(item);
                    },
                },
                {
                    Text: 'Cancel',
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelEdit(item),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $pnlEdit.removeClass("as-hidden");
                } else {
                    $pnlEdit.addClass("as-hidden");
                }
            }
        });

    }



    public Editing(currItem: KnockoutObservableType<InstructorItem>): void {
        console.log("Class edited: ", currItem);

        this._blk.Block();

        var i: InstructorItem = ko.mapping.toJS<InstructorItem>(currItem);

        Support.Post<InstructorsResponse>(
            this._cfg.Endpoint + "?action=edit&realm=instructors",
            i
            ,
        ).then((accept) => {

            this.Edited(currItem, accept.Item);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Edited(currItem: KnockoutObservableType<InstructorItem>,
        item: InstructorItem): void {
        /// MAPPING THE RESULTING OBJECT ONTO THE ORIGINAL OBJECT.
        /// 
        let iof: number = this.Items.indexOf(currItem);

        currItem = ko.mapping.fromJS(item, {});

        console.log("Editing completed !", currItem, item);
    }





    private CancelEdit(item: KnockoutObservableType<InstructorItem>): void {

        /// RESTORE OUR BACKED UP ITEM.
        item = ko.mapping.fromJS(this._copy, {}, item);

    }



    public Delete(sender: KnockoutObservableType<InstructorItem>): void {

        let fullName: string = Support.Concat(" ", sender.FName(), sender.LName());

        this._mdl.Confirm(
            `Are you sure you want to Delete Instructor
                <strong>${ fullName}</strong>`,
            (result: boolean) => {
                if (result) {
                    this.Deleting(sender);
                }
            },
            "Confirm Delete of Instructor"
        );
    }



    private Deleting(sender: KnockoutObservableType<InstructorItem>): void {

        this._blk.Block();

        var deleteObj: InstructorItem = ko.mapping.toJS<InstructorItem>(sender);

        Support.Post<InstructorsResponse>(
            this._cfg.Endpoint + "?action=delete&realm=instructors",
            deleteObj
            ,
        ).then((accept) => {

            this.Deleted(sender);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Deleted(sender: KnockoutObservableType<InstructorItem>): void {
        let iof: number = this.Items.indexOf(sender);
        this.Items.splice(iof, 1);
    }





    private Load(): void {
        this._blk.Block();

        Support.Post<InstructorsResponse>(
            this._cfg.Endpoint + "?action=load&realm=instructors",
            {}
            ,
        ).then((accept) => {

            this.Loaded(accept.Items);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Loaded(items: InstructorItem[]): void {

        /// ENSURING AN EMPTY COLLECTION IF NULL RESULTS
        if (items == null) items = [];

        this.Items = ko.mapping.fromJS(items);

        this.NewItem = ko.mapping.fromJS(this._emptyItem, {});

        // this._emptyItem = emptyItem;

        /*
        WE CAN APPLY BINDINGS JUST NOW THAT WE HAVE LOADED 
        ALL OUR NECESSARY OBJECTS.
        */

        ko.applyBindings(this, $(this._cfg.Panel)[0]);

        console.log("Loading completed, loaded %s items", items.length);
    }







    public ShowInsert(): void {

        this._mdl.Display({
            Title: 'Insert Instructor',
            DomSelector: this._cfg.InsertPanel,
            Buttons: [
                {
                    Text: "Insert Instructor",
                    Class: 'btn btn-primary',
                    Callback: (evt) => this.Inserting(),
                },
                {
                    Text: "Cancel",
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelInsert(),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $(this._cfg.InsertPanel).removeClass("as-hidden");
                } else {
                    $(this._cfg.InsertPanel).addClass("as-hidden");
                }
            }
        });
    }



    private PostError(msg: any) {
        this._mdl.Alert(msg, null, "Error :(");
    };



    private Inserting(): void {

        this._blk.Block();

        var insertObj: InstructorItem = ko.mapping.toJS<InstructorItem>(this.NewItem);

        Support.Post<InstructorsResponse>(
            this._cfg.Endpoint + "?action=insert&realm=instructors",
            insertObj
            ,
        ).then((accept) => {

            this.Inserted(accept.Item);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });

    }



    private Inserted(newItem: InstructorItem) {

        /// CREATE A KO OBJECT FROM THE RESULTING OBJECT.
        ///
        let newObj = ko.mapping.fromJS(newItem);

        /// PUSH IT TO THE COLLECTION.
        ///
        this.Items.push(newObj);

        /*
        CLEAR THE INSERT FORM
        */
        this.ClearInsertForm();
    }



    private CancelInsert(): void {
        /*
        CLEAR THE INSERT FORM
        */
        this.ClearInsertForm();
    }



    private ClearInsertForm(): void {
        ko.mapping.fromJS(this._emptyItem, this.NewItem);
    }





    public Concat(...args: string[]): string {
        var rval = Support.Concat(" ", ...args);
        return rval;
    }






    private Setup(): void {

        this._emptyItem = {
            About: null,
            Email: null,
            FName: null,
            LName: null,
            RecordID: 0,
        };

        /// ENSURING THERE IS AN EMPTY COLLECTION TO WORK WITH INITIALLY.
        /// 
        this.Load();
    }

}















// WEBPACK FOOTER //
// ./js/TS_Instructors.ts